import { Premium } from './Premium';
import React, { useState, useEffect } from "react";
import "./allagents.scss";
import axios from "axios";
import DataTable from "./DataTable";
import DataTableLeaders from "./DataTableLeaders/DataTableLeaders";
import DataTableSpecialAccess from "./DataTableSpecialAccess/DataTableSpecialAccess";
import { useHistory } from "react-router-dom";

import ReactPaginate from "react-paginate";
import moment from "moment";
import { Api_Url } from "../../../utils/ApiUrl";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Modal, Dropdown } from "react-bootstrap";
import Multiselect from "multiselect-react-dropdown";
import Specialaccess from "./Specialaccess";
import useAdminAllowed from '../../../hooks/userManagement/useAdminAllowed';

const ViewDetail = ({
  setRoutes,
  user,
  userDel,
  setUserDel,
  setShow,
  setBlockUnblock,
  blockUnblock,
  tomiPrice,
  usdPrice,
  btcPrice,
  pepePrice,
  linkPrice,
  uniPrice,
  dopPrice,
  gemsPrice,
  privateSaleFilter,
  setPreData,
  preData
}) => {
//  console.log(preData, 'preData ViewDetail')
  
  const history = useHistory();
  const [loader, setLoader] = useState(false);

  const [transactions, setTransactions] = useState([]);
  const [specialAccessData, setSpecialAccessData] = useState([]);

  const [purchases, setPurchases] = useState(null);
  const [leaderscount, setleaderscount] = useState(null);
  const [accessCodeToggle, setAccessCodeToggle] = useState(true);
  const [checkAdmin, isAdmin] = useAdminAllowed();

  const [dops, setDops] = useState(null);
  const [search, setSearch] = useState("");
  let tok = localStorage.getItem("accessToken");
  let project = localStorage.getItem("project");

  // const [usdPrice, setUsdPrice] = useState(0);
  const [page, setPage] = useState(0);
  const [pageCountAgent, setPageCountAgent] = useState(0);

  const [earnings, setEarnings] = useState(null);

  const [agents, setAgents] = useState([]);

  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [limit, setLimit] = useState(1);
  const [pages, setPages] = useState([]);
  const [code, setCode] = useState([]);
  const [page1, setPage1] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [leaderNames, setLeaderNames] = useState([]);
  const [leaderFilter, setLeaderFilter] = useState("");
  const [roleTypeFilter, setRoleTypeFilter] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [searchQueryNames, setSearchQueryNames] = useState("");

  const [orderField, setOrderField] = useState("transactionTime");
  const [orderDirection, setOrderDirection] = useState("-1");

  const [orderFieldAgents, setOrderFieldAgents] = useState("createdAt");
  const [orderDirectionAgents, setOrderDirectionAgents] = useState("-1");
  const [tabKey, setTabKey] = useState("transactions");

  const [specialAccess, setSpecialAccess] = useState([]);
  const [addSpecialAccess, setAddSpecialAccess] = useState([]);

  const [removeSpecialAccess, setRemoveSpecialAccess] = useState([]);

  const [godLeadersList, setGodLeadersList] = useState([]);
  const [minimumBuy, setMinimumBuy] = useState("");

  const [newWalletAddress, setNewWalletAddress] = useState("");

  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);

  const [show123, setShow123] = useState(false);
  const handleClose123 = () => setShow123(false);

  useEffect(() => {
    getLeaderNames();
  }, []);

  // useEffect(() => {
  //   if (userDel) {
  //     getDashboardData();
  //   }
  // }, [userDel]);

  const changeMinimumBuy = () => {
    const val = localStorage.getItem("accessToken");

    var config = {
      method: "patch",
      url: `${Api_Url}/users/${userDel?._id}/buying-limit`,

      headers: {
        Authorization: "Bearer " + val,
      },
      data: {
        leaderRole: userDel?.role,
        minimumBuy: minimumBuy,
      },
    };
    axios(config)
      .then(function (response) {
        getData();
        handleClose123();
      })
      .catch(function (error) {
        // toast.error(error?.response?.data?.message);
        if (error?.response?.status == 401) {
          // localStorage.removeItem("accessToken");
          // history.push("/");
        }
      });
  };

  const specialAccessList = () => {
    const val = localStorage.getItem("accessToken");

    var config = {
      method: "get",
      url: `${Api_Url}/users/god-leaders?limit=1000`,

      headers: {
        Authorization: "Bearer " + val,
      },
    };
    axios(config)
      .then(function (response) {
        setGodLeadersList(response?.data?.data);
      })
      .catch(function (error) {
        // toast.error(error?.response?.data?.message);
        if (error?.response?.status == 401) {
          // localStorage.removeItem("accessToken");
          // history.push("/");
        }
      });
  };

  const editSpecialAccessList = () => {
    setLoader(true);
    const val = localStorage.getItem("accessToken");

    var config = {
      method: "patch",
      url: `${Api_Url}/users/${userDel?._id}/god-leader`,
      data: {
        role: userDel?.role,
        addSpecialAccess: addSpecialAccess,
        removeSpecialAccess: removeSpecialAccess,
      },
      headers: {
        Authorization: "Bearer " + val,
      },
    };
    axios(config)
      .then(function (response) {
        getData();
        handleClose1();
        setAddSpecialAccess([]);
        setRemoveSpecialAccess([]);
        setLoader(false);
      })
      .catch(function (error) {
        // toast.error(error?.response?.data?.message);
        setLoader(false);
        if (error?.response?.status == 401) {
          // localStorage.removeItem("accessToken");
          // history.push("/");
        }
      });
  };

  const getDashboardData = () => {
    var config = {
      method: "get",
      url: `${Api_Url}/users/${userDel?._id}/admin/leaders?limit=15&offset=1&&role=${userDel?.role}`,

      headers: {
        Authorization: "Bearer " + tok,
      },
    };

    let dynamicQuery = config.url;

    if (search) {
      dynamicQuery += `&by=${search}`;
    }

    config.url = dynamicQuery;
    axios(config)
      .then(function (res) {
        setLoader(false);
      })
      .catch(function (error) {
        setLoader(false);
      });
  };

  const toggleAccessCode = async () => {
    var config = {
      method: "patch",
      url: `${Api_Url}/users/${userDel?._id}/toggle-access-code`,

      headers: {
        Authorization: "Bearer " + tok,
      },
    };

    await axios(config)
      .then(function (res) {
        setLoader(false);
      })
      .catch(function (error) {
        setLoader(false);
      });
  };

  useEffect(() => {
    if (user && tabKey == "leaders") {
      GetAgents();
    } else if (user && tabKey == "special") {
      getSpecialAccessData();
    }
  }, [
    user,
    searchQuery,
    leaderFilter,
    roleTypeFilter,
    orderDirectionAgents,
    orderFieldAgents,
    tabKey,
    page,
  ]);

  const handlePageChange = (e) => {
    const selectedPage = e.selected;

    setPage1(selectedPage);
  };

  const getTransactionsData = () => {
    var config = {
      method: "post",
      // get api so don't need to add useAdminAllowed();
      url: `${Api_Url}/users/admin/single/all-transactions`,

      data: {
        limit: 10,
        offset: page1 + 1,
        ...(roleTypeFilter && { leaderType: roleTypeFilter }),
        id: userDel?._id,

        ...(privateSaleFilter?.length > 0 && {
          privateSaleFilter: privateSaleFilter,
        }),

        ...(search && { search: search }),

        orderField: orderField,
        orderDirection: orderDirection,
      },

      headers: {
        Authorization: "Bearer " + tok,
      },
    };

    axios(config)
      .then(function (res) {
        // console.log("trx data: ", res?.data?.data?.transactions);
        setTransactions(res?.data?.data?.transactions);
        setPageCount(res?.data?.data?.pages);
        setLoader(false);
      })
      .catch(function (error) {
        setLoader(false);
      });
  };

  const getLeaderNames = () => {
    const val = localStorage.getItem("accessToken");

    var config = {
      method: "get",
      url: `${Api_Url}/users/${userDel?._id}/leaders-names?limit=${500}&role=${
        userDel?.role
      }`,
      headers: {
        Authorization: "Bearer " + val,
      },
    };
    let dynamicQuery = config.url;

    if (searchQueryNames) {
      dynamicQuery += `&name=${encodeURIComponent(searchQueryNames)}`;
    }
    axios(config)
      .then(function (response) {
        setLeaderNames(response?.data?.data);
      })
      .catch(function (error) {
        if (error?.response?.status == 401) {
          // localStorage.removeItem("accessToken");
          // history.push("/");
        }
      });
  };

  const setSearchQuerying = (e) => {
    setSearchQuery(e);
    if (e === "") {
      GetAgents();
    }
  };

  const handleAgentsPageChange = (e) => {
    const selectedPage = e.selected;

    setPage(selectedPage);
  };

  const GetAgents = () => {
    // off?.preventDefault();
    const val = localStorage.getItem("accessToken");
    let valu = null;

    var config = {
      method: "post",
      // get api so don't need to add useAdminAllowed();
      url: `${Api_Url}/users/admin/single/leaders`,
      data: {
        limit: 10,
        offset: page + 1,
        ...(roleTypeFilter && { leaderType: roleTypeFilter }),
        id: userDel?._id,

        ...(privateSaleFilter?.length > 0 && {
          privateSaleFilter: privateSaleFilter,
        }),

        ...(searchQuery && { search: searchQuery }),

        orderField: orderFieldAgents,
        orderDirection: orderDirectionAgents,
      },
      headers: {
        Authorization: "Bearer " + val,
      },
    };

    axios(config)
      .then(function (response) {
        const resData = response?.data?.data;
        setCount(response.data.data.count);
        setAgents(resData?.agents);
        let arr = Array.from(Array(parseInt(response.data.data.pages)).keys());
        setPageCountAgent(response?.data?.data?.pages);

        setPages(arr);
        // setSearch('')

        setLoader(false);
      })
      .catch(function (error) {
        if (error?.response?.status == 401) {
          // localStorage.removeItem("accessToken");
          // history.push("/");
        }
        setLoader(false);
      });
  };

  const getSpecialAccessData = () => {
    var config = {
      method: "get",
      url: `${Api_Url}/users/${userDel?._id}/special-accesses?limit=10&offset=${
        page1 + 1
      }&role=${userDel?.role}`,

      headers: {
        Authorization: "Bearer " + tok,
      },
    };

    let dynamicQuery = config.url;

    // if (search) {
    //   dynamicQuery += `&by=${search}`;
    // }
    // if (orderField) {
    //   dynamicQuery += `&orderField=${orderField}&orderDirection=${orderDirection}`;
    // }

    // if (roleTypeFilter) {
    //   dynamicQuery += `&leaderType=${encodeURIComponent(roleTypeFilter)}`;
    // }
    config.url = dynamicQuery;
    axios(config)
      .then(function (res) {
        // console.log("trx data: ", res?.data?.data?.transactions);
        setSpecialAccessData(res?.data?.data?.specialAccesses);
        setPageCount(res?.data?.data?.pages);
        setLoader(false);
      })
      .catch(function (error) {
        setLoader(false);
      });
  };

  const getData = async () => {
    var config = {
      method: "post",
      // get api so don't need to add useAdminAllowed();
      url: `${Api_Url}/users/admin/leader`,
      data: {
        id: userDel?._id,
        ...(privateSaleFilter?.length > 0 && {
          privateSaleFilter: privateSaleFilter,
        }),
      },
      headers: {
        authorization: `Bearer ` + tok,
      },
    };
    axios(config)
      .then(function (response) {
        // console.log("user coount eth", response);
        const resData = response?.data?.data;
        setleaderscount(resData);
        setBlockUnblock(resData?.isDeleted);
        setMinimumBuy(resData?.minimumBuy);
        setAccessCodeToggle(resData?.accessCodeEnabled);
        setSpecialAccess(resData?.specialAccess);
      })
      .catch(function (error) {});
  };

  useEffect(() => {
    if (userDel) {
      getData();
    }
  }, [userDel]);

  function convertToTitleCase(input) {
    if (input) {
      let words = input
        .split("_")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );
      if (words[0] === "mini" || words[0] === "Mini") {
        return "Ambassador";
      }
      if (
        words[words.length - 1].toLowerCase() === "agent" &&
        (words[0] != "mini" || words[0] != "Mini")
      ) {
        words[words.length - 1] = "Leader";
      }
      if (words[0] === "super" || words[0] === "Super") {
        return "Super";
      } else if (words[0] !== "agent") {
        return words.join(" ");
      } else {
        return "Leader";
      }
    } else {
      return "";
    }
  }

  useEffect(() => {
    if (usdPrice && tabKey == "transactions") {
      getTransactionsData();
    }
  }, [
    usdPrice,
    userDel,
    search,
    orderDirection,
    orderField,
    tabKey,
    page1,
    roleTypeFilter,
  ]);

  // console.log("abbbbbbbbbbbbbbbbbbbbbbb", userDel?.role)
  const [showchange, setShowchange] = useState(false);

  const handleClosechange = () => setShowchange(false);
  const handleShowchange = () => setShowchange(true);

  const [showconfirmation, setShowconfirmation] = useState(false);

  const handleCloseconfirmation = () => setShowconfirmation(false);
  const handleShowconfirmation = () => setShowconfirmation(true);

  const [showchangesuccess, setShowchangesuccess] = useState(false);

  const handleClosechangesuccess = () => setShowchangesuccess(false);
  const handleShowchangesuccess = () => setShowchangesuccess(true);

  return (
    <>
      <section className="viewdetail">
        <div className="custom-container veiwdetaileinnerpage">
          <div className="main-heading">
            <button
              onClick={() => {
                setRoutes(false);
                setUserDel(null);
              }}
              className="btn-back"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
              >
                <path
                  d="M7.88916 1.93555L5.38776 1.93555L1.99471 7.99682L4.49612 7.99682L7.88916 1.93555Z"
                  fill="#FFF"
                />
                <path
                  d="M7.88916 14.0703L5.38776 14.0703L1.99471 8.00904L3.5712 6.96117L4.49612 8.00904L7.88916 14.0703Z"
                  fill="#FFF"
                />
                <path
                  d="M8.01642 6.85742H14.9615L13.6868 9.14313H6.7417L8.01642 6.85742Z"
                  fill="#FFF"
                />
              </svg>
              Back
            </button>
            {isAdmin &&  <div className="twice-btn">
              {user?.role == "admin" ? (
                <>
                  <Premium userDel={userDel} setUserDel={setUserDel} setPreData={setPreData}/>
                  <div className="set-custom-claim-text">
                    <div className="parent-toggle-switch-custom">
                      <div class="custom-toggle">
                        <input
                          type="checkbox"
                          class="checkbox"
                          id="checkbox"
                          checked={!accessCodeToggle}
                          onChange={(e) => {
                            toggleAccessCode();
                            setAccessCodeToggle(!accessCodeToggle);
                          }}
                        />
                        <label class="switch" for="checkbox">
                          <span class="slider"></span>
                        </label>
                      </div>
                    </div>
                    <h6>
                      {" "}
                      {accessCodeToggle == true ? "Disable" : "Enable"} this
                      Code
                    </h6>
                  </div>
                  {leaderscount?.role == "god_agent" ? (
                    <button
                      onClick={() => {
                        specialAccessList();
                        setShow1(true);
                      }}
                      className="btn-edit"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="21"
                        viewBox="0 0 20 21"
                        fill="none"
                      >
                        <path
                          d="M17.5 18.8333H2.5C2.15833 18.8333 1.875 18.55 1.875 18.2083C1.875 17.8666 2.15833 17.5833 2.5 17.5833H17.5C17.8417 17.5833 18.125 17.8666 18.125 18.2083C18.125 18.55 17.8417 18.8333 17.5 18.8333Z"
                          fill="#fff"
                        />
                        <path
                          d="M15.85 3.39999C14.2333 1.78332 12.65 1.74166 10.9917 3.39999L9.98333 4.40832C9.9 4.49166 9.86666 4.62499 9.9 4.74166C10.5333 6.94999 12.3 8.71666 14.5083 9.34999C14.5417 9.35832 14.575 9.36666 14.6083 9.36666C14.7 9.36666 14.7833 9.33332 14.85 9.26666L15.85 8.25832C16.675 7.44166 17.075 6.64999 17.075 5.84999C17.0833 5.02499 16.6833 4.22499 15.85 3.39999Z"
                          fill="#fff"
                        />
                        <path
                          d="M13.0083 10.1084C12.7667 9.99169 12.5333 9.87502 12.3083 9.74169C12.125 9.63335 11.95 9.51669 11.775 9.39169C11.6333 9.30002 11.4667 9.16669 11.3083 9.03335C11.2917 9.02502 11.2333 8.97502 11.1667 8.90835C10.8917 8.67502 10.5833 8.37502 10.3083 8.04169C10.2833 8.02502 10.2417 7.96669 10.1833 7.89169C10.1 7.79169 9.95833 7.62502 9.83333 7.43335C9.73333 7.30835 9.61666 7.12502 9.50833 6.94169C9.375 6.71669 9.25833 6.49169 9.14166 6.25835C8.9887 5.93057 8.55849 5.8332 8.30271 6.08897L3.61666 10.775C3.50833 10.8834 3.40833 11.0917 3.38333 11.2334L2.93333 14.425C2.85 14.9917 3.00833 15.525 3.35833 15.8834C3.65833 16.175 4.075 16.3334 4.525 16.3334C4.625 16.3334 4.725 16.325 4.825 16.3084L8.025 15.8584C8.175 15.8334 8.38333 15.7334 8.48333 15.625L13.1771 10.9312C13.4278 10.6806 13.3336 10.2493 13.0083 10.1084Z"
                          fill="#fff"
                        />
                      </svg>
                      Edit Special Access
                    </button>
                  ) : null}
                  <button
                    onClick={() => setShow(true)}
                    className={blockUnblock ? "btn-del-grn " : "btn-del"}
                  >
                   <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
  <path d="M7.5 7.8125C9.39848 7.8125 10.9375 6.27348 10.9375 4.375C10.9375 2.47652 9.39848 0.9375 7.5 0.9375C5.60152 0.9375 4.0625 2.47652 4.0625 4.375C4.0625 6.27348 5.60152 7.8125 7.5 7.8125Z" fill="white"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5625 8.44128H11.875C12.0825 8.44128 12.2806 8.52378 12.4275 8.67003C12.5738 8.81691 12.6562 9.01566 12.6562 9.22253V10.16C12.6562 10.4188 12.8663 10.6288 13.125 10.6288C13.3837 10.6288 13.5938 10.4188 13.5938 10.16V9.22253C13.5938 8.76691 13.4125 8.32941 13.0906 8.00753C12.7681 7.68503 12.3306 7.50378 11.875 7.50378C11.8637 7.50378 11.8519 7.50441 11.8406 7.50503C11.83 7.50441 11.8188 7.50378 11.8075 7.50378C11.725 7.50378 11.5925 7.50378 11.5669 7.50378H11.5625C11.1069 7.50378 10.6694 7.68503 10.3469 8.00753C10.025 8.32941 9.84375 8.76691 9.84375 9.22253V10.16C9.84375 10.4188 10.0537 10.6288 10.3125 10.6288C10.5713 10.6288 10.7812 10.4188 10.7812 10.16V9.22253C10.7812 9.01566 10.8637 8.81691 11.01 8.67003C11.1569 8.52378 11.355 8.44128 11.5625 8.44128Z" fill="white"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.78313 13.7574C8.66188 13.5224 8.59375 13.2556 8.59375 12.9724V10.7849C8.59375 10.2512 8.83688 9.77432 9.21875 9.45932V9.22245C9.21875 8.97182 9.25875 8.72495 9.33563 8.4912C8.75563 8.40057 8.13875 8.3512 7.5 8.3512C5.42375 8.3512 3.58563 8.87057 2.44438 9.6487C1.57375 10.2424 1.09375 10.9968 1.09375 11.7887V12.6949C1.09375 12.9768 1.20562 13.2474 1.405 13.4468C1.60438 13.6456 1.87438 13.7581 2.15625 13.7574H8.78313Z" fill="white"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M14.2188 12.9725V10.785C14.2188 10.1813 13.7288 9.69128 13.125 9.69128C12.3612 9.69128 11.0762 9.69128 10.3125 9.69128C9.70875 9.69128 9.21875 10.1813 9.21875 10.785V12.9725C9.21875 13.5769 9.70875 14.0663 10.3125 14.0663H13.125C13.7288 14.0663 14.2188 13.5769 14.2188 12.9725ZM11.25 11.5663V12.1913C11.25 12.45 11.46 12.66 11.7188 12.66C11.9775 12.66 12.1875 12.45 12.1875 12.1913V11.5663C12.1875 11.3075 11.9775 11.0975 11.7188 11.0975C11.46 11.0975 11.25 11.3075 11.25 11.5663Z" fill="white"/>
</svg>
                    {blockUnblock == true ? "Unblock" : "Block"}
                  </button>
                </>
              ) : null}
            </div>}
            {/* <div class="dropdown d-none">
                            <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                <img src="\assets\more-icon.svg" alt="img" className="img-fluid" />
                            </button>
                            <ul class="dropdown-menu">
                                <li><a class="dropdown-item" href="#"><img src="\assets\edit.svg" alt="img" className="img-fluid" />Edit</a></li>
                                <li><a class="dropdown-item" href="#"><img src="\assets\delete.svg" alt="img" className="img-fluid" />Delete</a></li>
                            </ul>
                        </div> */}

                        
          </div>
          <div className="inner-heading newheadingss newclassagent">
            <h4>
              {userDel?.name} - {convertToTitleCase(userDel?.role)} -{" "}
              <span>{leaderscount?.accessCode}</span>
            </h4>
            {userDel?.UserPremiumPlan ? (
              <span className="newspan">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                >
                  <path
                    d="M9.48486 15.2083H7.60986C6.6932 15.2083 5.9432 15.9583 5.9432 16.875V17.0833H5.10986C4.7682 17.0833 4.48486 17.3667 4.48486 17.7083C4.48486 18.05 4.7682 18.3333 5.10986 18.3333H15.1099C15.4515 18.3333 15.7349 18.05 15.7349 17.7083C15.7349 17.3667 15.4515 17.0833 15.1099 17.0833H14.2765V16.875C14.2765 15.9583 13.5265 15.2083 12.6099 15.2083H10.7349V13.3C10.5265 13.325 10.3182 13.3333 10.1099 13.3333C9.90153 13.3333 9.6932 13.325 9.48486 13.3V15.2083Z"
                    fill="#E79C0D"
                  />
                  <path
                    d="M15.5099 9.7C16.0599 9.49167 16.5432 9.15 16.9265 8.76667C17.7015 7.90833 18.2099 6.88333 18.2099 5.68333C18.2099 4.48333 17.2682 3.54166 16.0682 3.54166H15.6015C15.0599 2.43333 13.9265 1.66666 12.6099 1.66666H7.60987C6.2932 1.66666 5.15987 2.43333 4.6182 3.54166H4.15153C2.95153 3.54166 2.00986 4.48333 2.00986 5.68333C2.00986 6.88333 2.5182 7.90833 3.2932 8.76667C3.67653 9.15 4.15987 9.49167 4.70987 9.7C5.57653 11.8333 7.65987 13.3333 10.1099 13.3333C12.5599 13.3333 14.6432 11.8333 15.5099 9.7ZM12.4765 7.04166L11.9599 7.675C11.8765 7.76666 11.8182 7.95 11.8265 8.075L11.8765 8.89166C11.9099 9.39166 11.5515 9.65 11.0849 9.46666L10.3265 9.16667C10.2099 9.125 10.0099 9.125 9.8932 9.16667L9.13487 9.46666C8.6682 9.65 8.30987 9.39166 8.3432 8.89166L8.3932 8.075C8.40153 7.95 8.3432 7.76666 8.25987 7.675L7.7432 7.04166C7.4182 6.65833 7.55987 6.23333 8.0432 6.10833L8.83487 5.90833C8.95987 5.875 9.10987 5.75833 9.17653 5.65L9.6182 4.96666C9.8932 4.54166 10.3265 4.54166 10.6015 4.96666L11.0432 5.65C11.1099 5.75833 11.2599 5.875 11.3849 5.90833L12.1765 6.10833C12.6599 6.23333 12.8015 6.65833 12.4765 7.04166Z"
                    fill="#E79C0D"
                  />
                </svg>
                Premium LEADER
              </span>
            ) : null}
          </div>
          <div
            className={
              leaderscount?.role == "mini_agent"
                ? "bottom-cards  newclassagent nexxtclass"
                : "bottom-cards "
            }
          >
            {leaderscount?.role === "mini_agent" ? (
              ""
            ) : (
              <div className="single-card">
                <img
                  src="\assets\dashboard\noofagents.svg"
                  alt="img"
                  className="img-fluid"
                />
                <p>No. of Leaders</p>
                {leaderscount?.role === "god_agent" ? (
                  <>
                    <h6>
                      {leaderscount
                        ? leaderscount?.megas +
                          leaderscount?.leaders +
                          leaderscount?.supers +
                          leaderscount?.miniLeaders
                        : 0}
                    </h6>
                    <div className="bottom-text">
                      <p className="uni-text">
                        <span></span>
                        {leaderscount ? leaderscount?.megas : 0} Mega
                      </p>
                      <p className="uni-text">
                        <span></span>
                        {leaderscount ? leaderscount?.supers : 0} Super
                      </p>
                      <p className="uni-text">
                        <span></span>
                        {leaderscount ? leaderscount?.leaders : 0}{" "}
                        {leaderscount?.leaders == 1 ||
                        leaderscount?.leaders == 0
                          ? "Leader"
                          : "Leaders"}
                      </p>
                      <p className="uni-text">
                        <span></span>
                        {leaderscount ? leaderscount?.miniLeaders : 0}{" "}
                        Ambassador
                      </p>
                    </div>
                  </>
                ) : leaderscount?.role === "mega_agent" ? (
                  <>
                    <h6>
                      {leaderscount
                        ? leaderscount?.leaders +
                          leaderscount?.supers +
                          leaderscount?.miniLeaders
                        : 0}
                    </h6>
                    <div className="bottom-text">
                      <p className="uni-text">
                        <span></span>
                        {leaderscount ? leaderscount?.supers : 0} Super
                      </p>
                      <p className="uni-text">
                        <span></span>
                        {leaderscount ? leaderscount?.leaders : 0}{" "}
                        {leaderscount?.leaders == 1 ||
                        leaderscount?.leaders == 0
                          ? "Leader"
                          : "Leader's"}
                      </p>
                      <p className="uni-text">
                        <span></span>
                        {leaderscount ? leaderscount?.miniLeaders : 0}{" "}
                        Ambassador
                      </p>
                    </div>
                  </>
                ) : leaderscount?.role === "super_agent" ? (
                  <>
                    <h6>
                      {leaderscount
                        ? leaderscount?.leaders + leaderscount?.miniLeaders
                        : 0}
                    </h6>
                    <div className="bottom-text">
                      <p className="uni-text">
                        <span></span>
                        {leaderscount ? leaderscount?.leaders : 0}{" "}
                        {leaderscount?.leaders == 1 ||
                        leaderscount?.leaders == 0
                          ? "Leader"
                          : "Leader's"}
                      </p>
                      <p className="uni-text">
                        <span></span>
                        {leaderscount ? leaderscount?.miniLeaders : 0}{" "}
                        Ambassador
                      </p>
                    </div>
                  </>
                ) : leaderscount?.role === "agent" ? (
                  <>
                    <h6>{leaderscount ? leaderscount?.miniLeaders : 0}</h6>
                    <div className="bottom-text">
                      <p className="uni-text">
                        <span></span>
                        {leaderscount ? leaderscount?.miniLeaders : 0}{" "}
                        Ambassador
                      </p>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
            )}

            <div className="single-card">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M9 8C9 9.65685 10.3431 11 12 11C13.6569 11 15 9.65685 15 8M3 16.8002V7.2002C3 6.08009 3 5.51962 3.21799 5.0918C3.40973 4.71547 3.71547 4.40973 4.0918 4.21799C4.51962 4 5.08009 4 6.2002 4H17.8002C18.9203 4 19.4796 4 19.9074 4.21799C20.2837 4.40973 20.5905 4.71547 20.7822 5.0918C21 5.5192 21 6.07899 21 7.19691V16.8036C21 17.9215 21 18.4805 20.7822 18.9079C20.5905 19.2842 20.2837 19.5905 19.9074 19.7822C19.48 20 18.921 20 17.8031 20H6.19691C5.07899 20 4.5192 20 4.0918 19.7822C3.71547 19.5905 3.40973 19.2842 3.21799 18.9079C3 18.4801 3 17.9203 3 16.8002Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
              <p>Number of Purchases</p>

              <h6>
                {leaderscount?.totalDirectSales +
                  leaderscount?.totalInDirectSales}
              </h6>

              <div className="bottom-text">
                <p className="uni-text">
                  <span></span>
                  {leaderscount?.totalDirectSales} Direct
                </p>
                <p className="uni-text">
                  <span></span>
                  {leaderscount?.totalInDirectSales} Indirect
                </p>
              </div>
            </div>
            <div className="single-card">
             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M13.2565 20.4041C9.60134 22.5144 4.92746 21.2621 2.81713 17.6069C0.706796 13.9517 1.95916 9.2778 5.61436 7.16747C9.26956 5.05714 13.9434 6.3095 16.0538 9.9647C18.1641 13.6199 16.9117 18.2938 13.2565 20.4041Z" stroke="white" stroke-width="1.5"/>
  <path d="M9.71289 3.31759C12.9689 0.631975 17.7855 1.09435 20.4711 4.35033C23.1567 7.60632 22.6944 12.4229 19.4384 15.1086" stroke="white" stroke-width="1.5"/>
  <rect x="9.38867" y="10.4834" width="4.79332" height="4.79332" transform="rotate(45 9.38867 10.4834)" fill="white"/>
</svg>
              <p>Tokens Purchased</p>
              {usdPrice && leaderscount ? (
                <h6>
                  {parseInt(leaderscount?.totalDop?.toFixed(2)).toLocaleString(
                    "en-US"
                  )}{" "}
                  &nbsp;Tokens
                </h6>
              ) : (
                <h6>0.00 Tokens</h6>
              )}
              <div className="bottom-text">
                <p className="uni-text">
                  <span></span>
                  {leaderscount
                    ? parseInt(
                        leaderscount?.totalDopDirect?.toFixed(4)
                      ).toLocaleString("en-US")
                    : 0}
                </p>
                <p className="uni-text">
                  <span></span>~
                  {leaderscount
                    ? parseInt(
                        leaderscount?.totalDopIndirect?.toFixed(4)
                      ).toLocaleString("en-US")
                    : 0}
                </p>
              </div>
            </div>
            <div className="single-card">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M18.6895 15.4594L6.58086 15.4593L6.58086 13.5855L18.6895 13.5855L18.6895 15.4594Z" fill="white"/>
  <path d="M20.2041 9.11768L8.0955 9.11767L8.81626 7.2438L20.2041 7.2438L20.2041 9.11768Z" fill="white"/>
  <path d="M6.07715 5.8739L3.12206 5.8739L3.12206 4.00002L6.07715 4.00002L6.07715 5.8739Z" fill="white"/>
  <path d="M16.9153 14.972L18.7254 7.24332L20.2036 7.24332L20.2036 9.11719L18.7254 15.4569L16.9153 14.972Z" fill="white"/>
  <path d="M8.37933 15.0078L7.00989 8.50446L5.19979 8.98945L6.56923 15.4928L8.37933 15.0078Z" fill="white"/>
  <path d="M8.37834 15.0085L6.04784 4.02005L4.23774 4.50505L6.56824 15.4935L8.37834 15.0085Z" fill="white"/>
  <mask id="path-7-inside-1_1178_62683" fill="white">
    <ellipse cx="9.82491" cy="18.3783" rx="1.58565" ry="1.62163"/>
  </mask>
  <path d="M11.4106 18.3783H9.78362C9.78362 18.3826 9.78322 18.385 9.78302 18.3859C9.78281 18.387 9.78261 18.3875 9.78252 18.3878C9.78222 18.3885 9.78203 18.3884 9.78288 18.3875C9.78375 18.3867 9.78763 18.383 9.79621 18.3793C9.80057 18.3774 9.80567 18.3757 9.81122 18.3746C9.81687 18.3734 9.82166 18.373 9.82491 18.373V20V21.6269C11.6334 21.6269 13.0375 20.1379 13.0375 18.3783H11.4106ZM9.82491 20V18.373C9.82816 18.373 9.83295 18.3734 9.8386 18.3746C9.84415 18.3757 9.84925 18.3774 9.85362 18.3793C9.8622 18.383 9.86607 18.3867 9.86694 18.3875C9.8678 18.3884 9.8676 18.3885 9.86731 18.3878C9.86722 18.3875 9.86701 18.387 9.8668 18.3859C9.86661 18.385 9.86621 18.3826 9.86621 18.3783H8.23926H6.61231C6.61231 20.1379 8.01643 21.6269 9.82491 21.6269V20ZM8.23926 18.3783H9.86621C9.86621 18.3741 9.86661 18.3717 9.8668 18.3707C9.86701 18.3697 9.86722 18.3691 9.86731 18.3689C9.8676 18.3682 9.8678 18.3683 9.86694 18.3691C9.86607 18.37 9.8622 18.3737 9.85362 18.3774C9.84925 18.3793 9.84415 18.381 9.8386 18.3821C9.83295 18.3833 9.82816 18.3837 9.82491 18.3837V16.7567V15.1298C8.01643 15.1298 6.61231 16.6188 6.61231 18.3783H8.23926ZM9.82491 16.7567V18.3837C9.82166 18.3837 9.81687 18.3833 9.81122 18.3821C9.80567 18.381 9.80057 18.3793 9.79621 18.3774C9.78763 18.3737 9.78375 18.37 9.78288 18.3691C9.78203 18.3683 9.78222 18.3682 9.78252 18.3689C9.78261 18.3691 9.78281 18.3697 9.78302 18.3707C9.78322 18.3717 9.78362 18.3741 9.78362 18.3783H11.4106H13.0375C13.0375 16.6188 11.6334 15.1298 9.82491 15.1298V16.7567Z" fill="white" mask="url(#path-7-inside-1_1178_62683)"/>
  <mask id="path-9-inside-2_1178_62683" fill="white">
    <ellipse cx="15.446" cy="18.3779" rx="1.58565" ry="1.62163"/>
  </mask>
  <path d="M17.0317 18.3779H15.4047C15.4047 18.3821 15.4043 18.3845 15.4041 18.3855C15.4039 18.3865 15.4037 18.387 15.4036 18.3873C15.4033 18.388 15.4031 18.3879 15.404 18.3871C15.4048 18.3862 15.4087 18.3825 15.4173 18.3788C15.4217 18.3769 15.4268 18.3752 15.4323 18.3741C15.438 18.3729 15.4428 18.3725 15.446 18.3725V19.9995V21.6264C17.2545 21.6264 18.6586 20.1374 18.6586 18.3779H17.0317ZM15.446 19.9995V18.3725C15.4493 18.3725 15.454 18.3729 15.4597 18.3741C15.4652 18.3752 15.4703 18.3769 15.4747 18.3788C15.4833 18.3825 15.4872 18.3862 15.488 18.3871C15.4889 18.3879 15.4887 18.388 15.4884 18.3873C15.4883 18.387 15.4881 18.3865 15.4879 18.3855C15.4877 18.3845 15.4873 18.3821 15.4873 18.3779H13.8604H12.2334C12.2334 20.1374 13.6375 21.6264 15.446 21.6264V19.9995ZM13.8604 18.3779H15.4873C15.4873 18.3736 15.4877 18.3712 15.4879 18.3702C15.4881 18.3692 15.4883 18.3687 15.4884 18.3684C15.4887 18.3677 15.4889 18.3678 15.488 18.3686C15.4872 18.3695 15.4833 18.3732 15.4747 18.3769C15.4703 18.3788 15.4652 18.3805 15.4597 18.3816C15.454 18.3828 15.4493 18.3832 15.446 18.3832V16.7562V15.1293C13.6375 15.1293 12.2334 16.6183 12.2334 18.3779H13.8604ZM15.446 16.7562V18.3832C15.4428 18.3832 15.438 18.3828 15.4323 18.3816C15.4268 18.3805 15.4217 18.3788 15.4173 18.3769C15.4087 18.3732 15.4048 18.3695 15.404 18.3686C15.4031 18.3678 15.4033 18.3677 15.4036 18.3684C15.4037 18.3687 15.4039 18.3692 15.4041 18.3702C15.4043 18.3712 15.4047 18.3736 15.4047 18.3779H17.0317H18.6586C18.6586 16.6183 17.2545 15.1293 15.446 15.1293V16.7562Z" fill="white" mask="url(#path-9-inside-2_1178_62683)"/>
</svg>
              <p>Purchased Amount</p>
              {leaderscount ? (
                <>
                  <h6 className="datahead">
                    ~$
                    {parseFloat(
                      (leaderscount?.totalAmountInUsd || 0)

                        // +
                        // dopPrice * leaderscount?.totalDopTokenDirect +
                        // btcPrice * leaderscount?.totalWbtcDirect +
                        // leaderscount?.totalUsdcDirect +
                        // pepePrice * leaderscount?.totalPepeDirect +
                        // linkPrice * leaderscount?.totalLinkDirect +
                        // uniPrice * leaderscount?.totalUniDirect +
                        // usdPrice * leaderscount?.totalEthIndirect +
                        // leaderscount?.totalUsdtIndirect +
                        // dopPrice * leaderscount?.totalDopTokenIndirect +
                        // btcPrice * leaderscount?.totalWbtcIndirect +
                        // leaderscount?.totalUsdcIndirect +
                        // pepePrice * leaderscount?.totalPepeIndirect +
                        // linkPrice * leaderscount?.totalLinkIndirect +
                        // uniPrice * leaderscount?.totalUniIndirect
                        ?.toFixed(2)
                    ).toLocaleString("en-US")}{" "}
                  </h6>
                </>
              ) : (
                <h6 className="datahead">~$0.00 USD</h6>
              )}

              <div className="bottom-text">
                <p className="uni-text">
                  <span></span>
                  {/* ? (user?.totalEth + user?.totalEthIndirect)?.toFixed(4) */}
                  Direct ~$
                  {leaderscount
                    ? parseFloat(
                        (leaderscount?.directAmountInUsd || 0)?.toFixed(2)
                      )?.toLocaleString()
                    : 0}{" "}
                </p>{" "}
                <p className="uni-text">
                  <span></span>
                  {/* ? (user?.totalEth + user?.totalEthIndirect)?.toFixed(4) */}
                  Indirect ~$
                  {leaderscount
                    ? parseFloat(
                        (leaderscount?.indirectAmountInUsd || 0)?.toFixed(2)
                      )?.toLocaleString()
                    : 0}{" "}
                </p>
                {/*                
               
               
                <p className="uni-text">
                  <span></span>
                  {leaderscount
                    ? (
                        (leaderscount?.totalEthDirect || 0) +
                        (leaderscount?.totalEthIndirect || 0)
                      )?.toFixed(4)
                    : 0}{" "}
                  ETH
                </p>
                <p className="uni-text">
                  <span></span>
                  {leaderscount
                    ? parseFloat(
                        (
                          (leaderscount?.totalUsdtDirect || 0) +
                          (leaderscount?.totalUsdtIndirect || 0)
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                    : 0}{" "}
                  USDT
                </p>
                <p className="uni-text">
                  <span></span>
                  {leaderscount
                    ? parseFloat(
                        (
                          (leaderscount?.totalUsdcDirect || 0) +
                          (leaderscount?.totalUsdcIndirect || 0)
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                    : 0}{" "}
                  USDC
                </p>
                <p className="uni-text">
                  <span></span>
                  {leaderscount
                    ? parseFloat(
                        (
                          (leaderscount?.totalDopTokenDirect || 0) +
                          (leaderscount?.totalDopTokenIndirect || 0)
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                    : 0}{" "}
                  DOP
                </p>
                <p className="uni-text">
                  <span></span>
                  {leaderscount
                    ? parseFloat(
                        (
                          (leaderscount?.totalWbtcDirect || 0) +
                          (leaderscount?.totalWbtcIndirect || 0)
                        )?.toFixed(6)
                      )?.toLocaleString("en-US")
                    : 0}{" "}
                  WBTC
                </p>
                <p className="uni-text">
                  <span></span>
                  {leaderscount
                    ? parseFloat(
                        (
                          (leaderscount?.totalPepeDirect || 0) +
                          (leaderscount?.totalPepeIndirect || 0)
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                    : 0}{" "}
                  PEPE
                </p>
                <p className="uni-text">
                  <span></span>
                  {leaderscount
                    ? parseFloat(
                        (
                          (leaderscount?.totalLinkDirect || 0) +
                          (leaderscount?.totalLinkIndirect || 0)
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                    : 0}{" "}
                  LINK
                </p>
                <p className="uni-text">
                  <span></span>
                  {leaderscount
                    ? parseFloat(
                        (
                          (leaderscount?.totalUniDirect || 0) +
                          (leaderscount?.totalUniIndirect || 0)
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                    : 0}{" "}
                  UNI
                </p> */}
              </div>
              {leaderscount?.totalAmountInUsd > 0 ? (
                <div className="valuemaindiv">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      <img
                        src="\assets\Caret_Down_MD.svg"
                        alt="arrowimg"
                        className="arrowimg"
                      />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <div className="teamsdrops">
                        {[
                          {
                            label: "ETH",
                            value:
                              (leaderscount?.totalEthDirect || 0) +
                              (leaderscount?.totalEthIndirect || 0),
                            decimals: 4,
                          },
                          {
                            label: "USDT",
                            value:
                              (leaderscount?.totalUsdtDirect || 0) +
                              (leaderscount?.totalUsdtIndirect || 0),
                            decimals: 2,
                          },
                          {
                            label: "USDC",
                            value:
                              (leaderscount?.totalUsdcDirect || 0) +
                              (leaderscount?.totalUsdcIndirect || 0),
                            decimals: 2,
                          },
                          {
                            label: "DOP",
                            value:
                              (leaderscount?.totalDopTokenDirect || 0) +
                              (leaderscount?.totalDopTokenIndirect || 0),
                            decimals: 2,
                          },
                          {
                            label: "WBTC",
                            value:
                              (leaderscount?.totalWbtcDirect || 0) +
                              (leaderscount?.totalWbtcIndirect || 0),
                            decimals: 6,
                          },
                          {
                            label: "PEPE",
                            value:
                              (leaderscount?.totalPepeDirect || 0) +
                              (leaderscount?.totalPepeIndirect || 0),
                            decimals: 2,
                          },
                          {
                            label: "LINK",
                            value:
                              (leaderscount?.totalLinkDirect || 0) +
                              (leaderscount?.totalLinkIndirect || 0),
                            decimals: 2,
                          },
                          {
                            label: "UNI",
                            value:
                              (leaderscount?.totalUniDirect || 0) +
                              (leaderscount?.totalUniIndirect || 0),
                            decimals: 2,
                          },
                          {
                            label: "TOMI",
                            value:
                              (leaderscount?.totalTomiDirect || 0) +
                              (leaderscount?.totalTomiIndirect || 0),
                            decimals: 2,
                          },
                          {
                            label: "GEMS",
                            value:
                              (leaderscount?.totalGemsDirect || 0) +
                              (leaderscount?.totalGemsIndirect || 0),
                            decimals: 2,
                          },
                        ]
                          .filter((token) => token.value > 0) // Show only non-zero values
                          .map((token, index) => (
                            <div className="innerteamdrop" key={index}>
                              <p className="teamdroppara">{token.label}</p>
                              <h6 className="teamdrophead">
                                {parseFloat(
                                  token.value.toFixed(token.decimals)
                                )}
                              </h6>
                            </div>
                          ))}
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              ) : null}
            </div>
            <div className="single-card">
             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M9 11V20M9 11H4.59961C4.03956 11 3.75981 11 3.5459 11.109C3.35774 11.2049 3.20487 11.3577 3.10899 11.5459C3 11.7598 3 12.04 3 12.6001V20H9M9 11V5.6001C9 5.04004 9 4.75981 9.10899 4.5459C9.20487 4.35774 9.35774 4.20487 9.5459 4.10899C9.75981 4 10.0396 4 10.5996 4H13.3996C13.9597 4 14.2403 4 14.4542 4.10899C14.6423 4.20487 14.7948 4.35774 14.8906 4.5459C14.9996 4.75981 15 5.04005 15 5.6001V8M9 20H15M15 20L21 20.0001V9.6001C21 9.04005 20.9996 8.75981 20.8906 8.5459C20.7948 8.35774 20.6429 8.20487 20.4548 8.10899C20.2409 8 19.9601 8 19.4 8H15M15 20V8" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
              <p>Earnings</p>
              {/* <h6>~50,000 USD</h6> */}
              {usdPrice && leaderscount ? (
                <h6 className="datahead">
                  ~$
                  {parseFloat(
                    (
                      usdPrice * leaderscount?.myEarningsEth +
                      leaderscount?.myEarningsUsdt +
                      dopPrice * leaderscount?.myEarningsDopToken +
                      btcPrice * leaderscount?.myEarningsWbtc +
                      leaderscount?.myEarningsUsdc +
                      pepePrice * leaderscount?.myEarningsPepe +
                      linkPrice * leaderscount?.myEarningsLink +
                      uniPrice * leaderscount?.myEarningsUni +
                      tomiPrice * leaderscount?.myEarningsTomi +
                      gemsPrice * leaderscount?.myEarningsGems
                    )?.toFixed(4)
                  ).toLocaleString("en-US")}{" "}
                </h6>
              ) : (
                <h6 className="datahead">~$0.00 USD</h6>
              )}
              <div className="bottom-text">
                {[
                  {
                    label: "ETH",
                    value: leaderscount?.myEarningsEth,
                    decimals: 5,
                  },
                  {
                    label: "USDT",
                    value: leaderscount?.myEarningsUsdt,
                    decimals: 4,
                  },
                  {
                    label: "USDC",
                    value: leaderscount?.myEarningsUsdc,
                    decimals: 4,
                  },
                  {
                    label: "DOP",
                    value: leaderscount?.myEarningsDopToken,
                    decimals: 4,
                  },
                  {
                    label: "WBTC",
                    value: leaderscount?.myEarningsWbtc,
                    decimals: 6,
                  },
                  {
                    label: "PEPE",
                    value: leaderscount?.myEarningsPepe,
                    decimals: 4,
                  },
                  {
                    label: "LINK",
                    value: leaderscount?.myEarningsLink,
                    decimals: 4,
                  },
                  {
                    label: "UNI",
                    value: leaderscount?.myEarningsUni,
                    decimals: 4,
                  },
                  {
                    label: "TOMI",
                    value: leaderscount?.myEarningsTomi,
                    decimals: 4,
                  },
                  {
                    label: "GEMS",
                    value: leaderscount?.myEarningsGems,
                    decimals: 4,
                  },
                ]
                  .filter((token) => token.value > 0) // Show only non-zero values
                  .map((token, index) => (
                    <p className="uni-text" key={index}>
                      <span></span>
                      {parseFloat(
                        token.value.toFixed(token.decimals)
                      ).toLocaleString("en-US")}{" "}
                      {token.label}
                    </p>
                  ))}
              </div>
            </div>
          </div>
          <div className="parent-new-card">
            <div className="main-headingg">
              <h6>General Information</h6>
            </div>
            <div className="bottom-cards1">
              <div className="inner-text">
                <p>Access Code</p>
                <h6>{leaderscount?.accessCode}</h6>
              </div>
              <div className="inner-text">
                <p>Name</p>
                <h6>{leaderscount?.name}</h6>
              </div>
              <div className="inner-text">
                <p>Direct Sale</p>
                {leaderscount?.totalDirectSales != 0 ||
                leaderscount?.totalInDirectSales != 0 ? (
                  <h6>
                    {parseInt(
                      (leaderscount?.totalDirectSales /
                        (leaderscount?.totalDirectSales +
                          leaderscount?.totalInDirectSales)) *
                        100
                    )?.toFixed(2)}
                    %
                  </h6>
                ) : (
                  <h6>0%</h6>
                )}
              </div>
              <div className="inner-text">
                <p>Indirect Sale</p>

                {leaderscount?.totalDirectSales != 0 ||
                leaderscount?.totalInDirectSales != 0 ? (
                  <h6>
                    {parseInt(
                      (leaderscount?.totalInDirectSales /
                        (leaderscount?.totalDirectSales +
                          leaderscount?.totalInDirectSales)) *
                        100
                    )?.toFixed(2)}
                    %
                  </h6>
                ) : (
                  <h6>0%</h6>
                )}
              </div>
              <div className="inner-text">
                <p>Created On</p>
                <h6>
                  {moment(leaderscount?.createdAt).format("DD/MM/YYYY hh:mm")}{" "}
                  UTC
                </h6>
              </div>
              <div className="inner-text">
                <p>Email address</p>
                <h6>{leaderscount?.email}</h6>
              </div>
              <div className="inner-text">
                <p>Owner’s Wallet Address</p>
                <h6 className="forflex">
                  {userDel?.walletAddress}
                  {/* <img
                    src="\assets\editi.svg"
                    alt="img"
                    style={{ cursor: "pointer" }}
                    onClick={handleShowchange}
                  /> */}
                  {/* // ?.slice(0, 11)}...
                  // {userDel?.walletAddress?.slice( */}
                  {/* //   userDel?.walletAddress?.length - 3,
                  //   userDel?.walletAddress?.length
                  // )} */}
                </h6>
              </div>
            </div>
            {user?.role == "admin" ? (
              <div className="bottom-cards2">
                <h4>Hierarchy</h4>
                <div className="parent-card">
                  <div className="inner-text">
                    <p>God Leader</p>
                    {leaderscount?.godAgent ? (
                      <>
                        {user?.role == "admin" ? (
                          <>
                            <a
                              onClick={() => {
                                setUserDel(leaderscount?.godAgent);
                              }}
                              href="#"
                            >
                              <h6 className="style-text">
                                {leaderscount?.godAgent?.name}
                              </h6>
                            </a>
                          </>
                        ) : (
                          <>
                            <h6>{leaderscount?.godAgent?.name}</h6>
                          </>
                        )}
                      </>
                    ) : (
                      <h6>None</h6>
                    )}
                  </div>
                  <div className="inner-text">
                    <p>Mega Leader</p>
                    {leaderscount?.megaAgent ? (
                      <>
                        {user?.role == "admin" ? (
                          <>
                            <a
                              onClick={() => {
                                setUserDel(leaderscount?.megaAgent);
                              }}
                              href="#"
                            >
                              <h6 className="style-text">
                                {leaderscount?.megaAgent?.name}
                              </h6>
                            </a>
                          </>
                        ) : (
                          <>
                            <h6>{leaderscount?.megaAgent?.name}</h6>
                          </>
                        )}
                      </>
                    ) : (
                      <h6>None</h6>
                    )}
                  </div>
                  <div className="inner-text">
                    <p>Super Leader</p>
                    {leaderscount?.superAgent ? (
                      <>
                        {user?.role == "admin" ? (
                          <>
                            <a
                              onClick={() => {
                                setUserDel(leaderscount?.superAgent);
                              }}
                              href="#"
                            >
                              <h6 className="style-text">
                                {leaderscount?.superAgent?.name}
                              </h6>
                            </a>
                          </>
                        ) : (
                          <>
                            <h6>{leaderscount?.superAgent?.name}</h6>
                          </>
                        )}
                      </>
                    ) : (
                      <h6>None</h6>
                    )}
                  </div>
                  <div className="inner-text">
                    <p>Leader</p>
                    {leaderscount?.agent ? (
                      <>
                        {user?.role == "admin" ? (
                          <>
                            <a
                              onClick={() => {
                                setUserDel(leaderscount?.agent);
                              }}
                              href="#"
                            >
                              <h6 className="style-text">
                                {leaderscount?.agent?.name}
                              </h6>
                            </a>
                          </>
                        ) : (
                          <>
                            <h6>{leaderscount?.agent?.name}</h6>
                          </>
                        )}
                      </>
                    ) : (
                      <h6>None</h6>
                    )}
                  </div>
                </div>
              </div>
            ) : null}
            {/* {user?.role == "admin" ? (
              <div className="bottom-cards33">
                <h6>Code Buying Limit</h6>
                <p onClick={() => setShow123(true)}>
                  $ {leaderscount?.minimumBuy ? leaderscount?.minimumBuy : 0}{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M17.5 18.3334H2.5C2.15833 18.3334 1.875 18.05 1.875 17.7084C1.875 17.3667 2.15833 17.0834 2.5 17.0834H17.5C17.8417 17.0834 18.125 17.3667 18.125 17.7084C18.125 18.05 17.8417 18.3334 17.5 18.3334Z"
                      fill="white"
                    />
                    <path
                      d="M15.85 2.90005C14.2333 1.28338 12.65 1.24172 10.9916 2.90005L9.98331 3.90838C9.89998 3.99172 9.86665 4.12505 9.89998 4.24172C10.5333 6.45005 12.3 8.21672 14.5083 8.85005C14.5416 8.85838 14.575 8.86672 14.6083 8.86672C14.7 8.86672 14.7833 8.83338 14.85 8.76672L15.85 7.75838C16.675 6.94172 17.075 6.15005 17.075 5.35005C17.0833 4.52505 16.6833 3.72505 15.85 2.90005Z"
                      fill="white"
                    />
                    <path
                      d="M13.0083 9.60829C12.7666 9.49163 12.5333 9.37496 12.3083 9.24163C12.125 9.13329 11.95 9.01663 11.775 8.89163C11.6333 8.79996 11.4666 8.66663 11.3083 8.53329C11.2916 8.52496 11.2333 8.47496 11.1666 8.40829C10.8916 8.17496 10.5833 7.87496 10.3083 7.54163C10.2833 7.52496 10.2416 7.46663 10.1833 7.39163C10.1 7.29163 9.95831 7.12496 9.83331 6.93329C9.73331 6.80829 9.61665 6.62496 9.50831 6.44163C9.37498 6.21663 9.25831 5.99163 9.14165 5.75829C8.98868 5.43051 8.55847 5.33314 8.3027 5.58891L3.61665 10.275C3.50831 10.3833 3.40831 10.5916 3.38331 10.7333L2.93331 13.925C2.84998 14.4916 3.00831 15.025 3.35831 15.3833C3.65831 15.675 4.07498 15.8333 4.52498 15.8333C4.62498 15.8333 4.72498 15.825 4.82498 15.8083L8.02498 15.3583C8.17498 15.3333 8.38331 15.2333 8.48331 15.125L13.1771 10.4312C13.4278 10.1805 13.3336 9.74924 13.0083 9.60829Z"
                      fill="white"
                    />
                  </svg>
                </p>
              </div>
            ) : null} */}

            {/* {user?.role == "admin" ? (
              <div className="bottom-cards2 bottom-cards3">
                <h4>Special Access</h4>
                <div className="parent-card">
                  {specialAccess?.length > 0
                    ? specialAccess?.map((item) => {
                        return (
                          <>
                            <div className="inner-text">
                              <p>God Leader</p>
                              {leaderscount?.role == "god_agent" ? (
                                <>
                                  <h6 className="style-text">{item?.name}</h6>
                                </>
                              ) : (
                                <h6>None</h6>
                              )}
                            </div>
                          </>
                        );
                      })
                    : null}
                </div>
              </div>
            ) : null} */}
          </div>
          {/* {user?.role == "admin" ? (
            <Specialaccess
              specialAccess={specialAccess}
              setUserDel={setUserDel}
              setShow1={setShow1}
            />
          ) : null} */}

          <Tabs
            defaultActiveKey="transactions"
            id="uncontrolled-tab-example"
            className="viewdetail-tabs"
            onSelect={(e) => {
              setTabKey(e);
            }}
          >
            <Tab eventKey="transactions" title="All Transactions">
              <div className="main-heading111">
                <div
                  className={
                    userDel?.role !== "agent"
                      ? "rightside-content fxrxxrxxrexxr"
                      : "rightside-content "
                  }
                >
                  <div
                    className=" custom-option-field"
                    style={{ width: "85%" }}
                  >
                    {/* <form onSubmit={(e) => GetSearch(e)}> */}
                    <input
                      onChange={(e) => setSearch(e.target.value)}
                      value={search}
                      type="search"
                      placeholder="Search..."
                    />
                    {/* </form> */}
                    <svg className="img-fluid search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
  <path d="M10.0008 8.73306C9.37556 9.70927 8.2814 10.3563 7.03612 10.3563C5.09321 10.3563 3.51818 8.78126 3.51818 6.83836C3.51818 4.89546 5.09321 3.32043 7.03612 3.32043C8.97902 3.32043 10.5541 4.89546 10.5541 6.83836C10.5541 7.39695 10.4239 7.92514 10.1922 8.39423L12.5736 8.39423C12.7124 7.89938 12.7866 7.37753 12.7866 6.83836C12.7866 3.66246 10.212 1.08789 7.03612 1.08789C3.86022 1.08789 1.28564 3.66246 1.28564 6.83836C1.28564 10.0143 3.86022 12.5888 7.03612 12.5888C8.66134 12.5888 10.1291 11.9146 11.1749 10.8306L10.0008 8.73306Z" fill="#85A8AE"/>
  <path d="M14.9076 16.8352L15.636 14.117L10.0373 8.66506L9.30901 11.3833L14.9076 16.8352Z" fill="#85A8AE"/>
</svg>
                   
                  </div>
                  {userDel?.role !== "mini_agent" && (
                    <div class="dropdown">
                      <button
                        class="dropdown-toggle"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        Type{" "}
                        <img
                          src="\assets\arrow-down.svg"
                          alt="img"
                          className="img-fluid"
                        />
                      </button>
                      {userDel?.role === "god_agent" && (
                        <ul class="dropdown-menu">
                          <li>
                            <a
                              onClick={() => setRoleTypeFilter("")}
                              class="dropdown-item"
                              href="#"
                            >
                              All Leaders
                            </a>
                          </li>
                          <li>
                            <a
                              onClick={() => setRoleTypeFilter("god_agent")}
                              class="dropdown-item"
                              href="#"
                            >
                              God Leader
                            </a>
                          </li>
                          <li>
                            <a
                              onClick={() => setRoleTypeFilter("mega_agent")}
                              class="dropdown-item"
                              href="#"
                            >
                              Mega Leader
                            </a>
                          </li>
                          <li>
                            <a
                              onClick={() => setRoleTypeFilter("super_agent")}
                              class="dropdown-item"
                              href="#"
                            >
                              Super Leader
                            </a>
                          </li>
                          <li>
                            <a
                              onClick={() => setRoleTypeFilter("agent")}
                              class="dropdown-item"
                              href="#"
                            >
                              Leader
                            </a>
                          </li>
                          <li>
                            <a
                              onClick={() => setRoleTypeFilter("mini_agent")}
                              class="dropdown-item"
                              href="#"
                            >
                              Ambassador
                            </a>
                          </li>
                        </ul>
                      )}
                      {userDel?.role === "mega_agent" && (
                        <ul class="dropdown-menu">
                          <li>
                            <a
                              onClick={() => setRoleTypeFilter("")}
                              class="dropdown-item"
                              href="#"
                            >
                              All Leaders
                            </a>
                          </li>
                          <li>
                            <a
                              onClick={() => setRoleTypeFilter("mega_agent")}
                              class="dropdown-item"
                              href="#"
                            >
                              Mega Leader
                            </a>
                          </li>
                          <li>
                            <a
                              onClick={() => setRoleTypeFilter("super_agent")}
                              class="dropdown-item"
                              href="#"
                            >
                              Super Leader
                            </a>
                          </li>
                          <li>
                            <a
                              onClick={() => setRoleTypeFilter("agent")}
                              class="dropdown-item"
                              href="#"
                            >
                              Leader
                            </a>
                          </li>
                          <li>
                            <a
                              onClick={() => setRoleTypeFilter("mini_agent")}
                              class="dropdown-item"
                              href="#"
                            >
                              Ambassador
                            </a>
                          </li>
                          {/* <li>
                          <a
                            onClick={() => GetFilterRole("god_agent")}
                            class="dropdown-item"
                            href="#"
                          >
                            God Leader
                          </a>
                        </li> */}
                        </ul>
                      )}
                      {userDel?.role === "super_agent" && (
                        <ul class="dropdown-menu">
                          <li>
                            <a
                              onClick={() => setRoleTypeFilter("")}
                              class="dropdown-item"
                              href="#"
                            >
                              All Leaders
                            </a>
                          </li>
                          <li>
                            <a
                              onClick={() => setRoleTypeFilter("agent")}
                              class="dropdown-item"
                              href="#"
                            >
                              Leader
                            </a>
                          </li>
                          <li>
                            <a
                              onClick={() => setRoleTypeFilter("mini_agent")}
                              class="dropdown-item"
                              href="#"
                            >
                              Ambassador
                            </a>
                          </li>
                        </ul>
                      )}
                      {userDel?.role === "agent" && (
                        <ul class="dropdown-menu">
                          <li>
                            <a
                              onClick={() => setRoleTypeFilter("")}
                              class="dropdown-item"
                              href="#"
                            >
                              All Leaders
                            </a>
                          </li>
                          <li>
                            <a
                              onClick={() => setRoleTypeFilter("mini_agent")}
                              class="dropdown-item"
                              href="#"
                            >
                              Ambassador
                            </a>
                          </li>
                        </ul>
                      )}
                    </div>
                  )}
                  {/* <button className="reset-btn-global">Reset</button> */}
                </div>
              </div>
              {transactions?.length > 0 ? (
                <DataTable
                  tomiPrice={tomiPrice}
                  transactions={transactions}
                  setTransactions={setTransactions}
                  user={user}
                  usdPrice={usdPrice}
                  page={page1}
                  pageCount={pageCount}
                  setOrderDirection={setOrderDirection}
                  setOrderField={setOrderField}
                />
              ) : (
                <p
                  className=""
                  style={{ color: "#fff", textAlign: "center", marginTop: 100 }}
                >
                  No data found!
                </p>
              )}
              <div className="footer-content mt-2">
                <div className="left-f">
                  {/* <h6>SHOWING 1-10 OF 145</h6> */}
                  {/* <h6>SHOWING 1-10 OF 145</h6> */}
                </div>
                <div className="right-f">
                  <nav aria-label="Page navigation example">
                    <ul class="pagination">
                      <nav aria-label="Page navigation example">
                        <ul class="text-center">
                          <ReactPaginate
                            previousLabel={
                         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M12.6665 8L3.33317 8" stroke="#042B33" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8 3.33329L3.33333 7.99996L8 12.6666" stroke="#042B33" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                            }
                            nextLabel={
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M3.3335 8L12.6668 8" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8 3.33329L12.6667 7.99996L8 12.6666" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                            }
                            pageClassName="page-item"
                            pageLinkClassName="page-link"
                            previousClassName="page-item"
                            previousLinkClassName="page-link"
                            nextClassName="page-item"
                            nextLinkClassName="page-link"
                            breakLabel="..."
                            breakClassName="page-item"
                            breakLinkClassName="page-link"
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={handlePageChange}
                            containerClassName="pagination"
                            activeClassName="active"
                            forcePage={page1}
                          ></ReactPaginate>
                        </ul>
                      </nav>
                    </ul>
                  </nav>
                </div>
              </div>
            </Tab>
            {userDel?.role != "mini_agent" ? (
              <Tab eventKey="leaders" title="All Leaders">
                <div className="main-heading2 ">
                  <div
                    className={
                      userDel?.role == "mini_agent"
                        ? "rightside-content gvcvtdvdvtdcvdtc"
                        : "rightside-content"
                    }
                  >
                    <div className="custom-option-field">
                      {/* <form onSubmit={(e) => GetAgents(e)}> */}
                      <input
                        type="search"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={(e) => {
                          setSearchQuery(e.target.value);
                        }}
                      />
                      {/* </form> */}
                      <img
                        style={{ cursor: "pointer" }}
                        src="\assets\search-icon.svg"
                        alt="img"
                        className="img-fluid search-icon"
                        // onClick={() => GetAgents()}
                      />
                    </div>
                    {userDel?.role == "mini_agent" ? (
                      ""
                    ) : (
                      <div class="dropdown">
                        <button
                          class="dropdown-toggle"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <div
                            // onClick={() => {
                            //   setRoleTypeFilter(roleTypeFilter);
                            // }}
                            className="se-custom-flex-gap"
                          >
                            {roleTypeFilter == "god_agent"
                              ? "God"
                              : roleTypeFilter == "mega_agent"
                              ? "Mega"
                              : roleTypeFilter == "super_agent"
                              ? "Super"
                              : roleTypeFilter == "agent"
                              ? "Leader "
                              : roleTypeFilter == "mini_agent"
                              ? "Ambassador "
                              : "By Role"}
                            <img
                              src="\assets\arrow-down.svg"
                              alt="img"
                              className="img-fluid"
                            />
                          </div>
                        </button>
                        {userDel?.role == "admin" ? (
                          <ul class="dropdown-menu">
                            <li>
                              <a
                                onClick={() => setRoleTypeFilter("")}
                                class="dropdown-item"
                                href="#"
                              >
                                All Leaders
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item"
                                href="#"
                                onClick={() => {
                                  setRoleTypeFilter("god_agent");
                                }}
                              >
                                God
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item"
                                href="#"
                                onClick={() => {
                                  setRoleTypeFilter("mega_agent");
                                }}
                              >
                                Mega
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item"
                                href="#"
                                onClick={() => {
                                  setRoleTypeFilter("super_agent");
                                }}
                              >
                                Super
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item"
                                href="#"
                                onClick={() => {
                                  setRoleTypeFilter("agent");
                                }}
                              >
                                Leader
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item"
                                href="#"
                                onClick={() => {
                                  setRoleTypeFilter("mini_agent");
                                }}
                              >
                                Ambassador
                              </a>
                            </li>
                          </ul>
                        ) : userDel?.role == "god_agent" ? (
                          <ul class="dropdown-menu">
                            <li>
                              <a
                                onClick={() => setRoleTypeFilter("")}
                                class="dropdown-item"
                                href="#"
                              >
                                All Leaders
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item"
                                href="#"
                                onClick={() => {
                                  setRoleTypeFilter("mega_agent");
                                }}
                              >
                                Mega
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item"
                                href="#"
                                onClick={() => {
                                  setRoleTypeFilter("super_agent");
                                }}
                              >
                                Super
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item"
                                href="#"
                                onClick={() => {
                                  setRoleTypeFilter("agent");
                                }}
                              >
                                Leader
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item"
                                href="#"
                                onClick={() => {
                                  setRoleTypeFilter("mini_agent");
                                }}
                              >
                                Ambassador
                              </a>
                            </li>
                          </ul>
                        ) : userDel?.role == "mega_agent" ? (
                          <ul class="dropdown-menu">
                            <li>
                              <a
                                onClick={() => setRoleTypeFilter("")}
                                class="dropdown-item"
                                href="#"
                              >
                                All Leaders
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item"
                                href="#"
                                onClick={() => {
                                  setRoleTypeFilter("super_agent");
                                }}
                              >
                                Super
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item"
                                href="#"
                                onClick={() => {
                                  setRoleTypeFilter("agent");
                                }}
                              >
                                Leader
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item"
                                href="#"
                                onClick={() => {
                                  setRoleTypeFilter("mini_agent");
                                }}
                              >
                                Ambassador
                              </a>
                            </li>
                          </ul>
                        ) : userDel?.role == "super_agent" ? (
                          <ul class="dropdown-menu">
                            <li>
                              <a
                                onClick={() => setRoleTypeFilter("")}
                                class="dropdown-item"
                                href="#"
                              >
                                All Leaders
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item"
                                href="#"
                                onClick={() => {
                                  setRoleTypeFilter("agent");
                                }}
                              >
                                Leader
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item"
                                href="#"
                                onClick={() => {
                                  setRoleTypeFilter("mini_agent");
                                }}
                              >
                                Ambassador
                              </a>
                            </li>
                          </ul>
                        ) : userDel?.role == "agent" ? (
                          <ul class="dropdown-menu">
                            <li>
                              <a
                                onClick={() => setRoleTypeFilter("")}
                                class="dropdown-item"
                                href="#"
                              >
                                All Leaders
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item"
                                href="#"
                                onClick={() => {
                                  setRoleTypeFilter("mini_agent");
                                }}
                              >
                                Ambassador
                              </a>
                            </li>
                          </ul>
                        ) : (
                          ""
                        )}
                      </div>
                    )}
                    <div class="dropdown">
                      <button
                        class="dropdown-toggle"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <div
                          // onClick={() => {
                          //   setLeaderFilter("");
                          // }}
                          className="se-custom-flex-gap"
                        >
                          {leaderFilter ? leaderFilter + " " : "By Name "}

                          <img
                            src="\assets\arrow-down.svg"
                            alt="img"
                            className="img-fluid"
                          />
                        </div>
                      </button>
                      <ul class="dropdown-menu set-custom-scrollbar">
                        <div className="custom-option-field drop-in-search-sticky">
                          <input type="search" placeholder="Search" />
                          <img
                            src="\assets\search-icon.svg"
                            alt="img"
                            className="img-fluid search-icon"
                          />
                        </div>
                        {leaderNames?.length > 0
                          ? leaderNames?.map((item) => {
                              return (
                                <>
                                  <li>
                                    <a
                                      class="dropdown-item"
                                      href="#"
                                      onClick={() => {
                                        setLeaderFilter(item?.name);
                                      }}
                                    >
                                      {item?.name}
                                    </a>
                                  </li>
                                </>
                              );
                            })
                          : null}
                      </ul>
                    </div>
                    {/* <button
                    className="reset-btn-global"
                    onClick={() => {
                      setLeaderFilter("");
                      setRoleTypeFilter("");
                      setSearchQuery("");
                    }}
                  >
                    Reset
                  </button> */}
                  </div>
                </div>
                {agents?.length > 0 ? (
                  <DataTableLeaders
                    // setUserDel={setUserDel}
                    btcPrice={btcPrice}
                    usdPrice={usdPrice}
                    tomiPrice={tomiPrice}
                    pepePrice={pepePrice}
                    linkPrice={linkPrice}
                    uniPrice={uniPrice}
                    dopPrice={dopPrice}
                    gemsPrice={gemsPrice}
                    currentPage={currentPage}
                    GetAllRounds={GetAgents}
                    pages={pages}
                    GetAgents={GetAgents}
                    page={page}
                    pageCount={pageCountAgent}
                    handlePageChange={handleAgentsPageChange}
                    offset={offset}
                    setOffset={setOffset}
                    agents={agents}
                    setAgents={setAgents}
                    setRoutes={setRoutes}
                    sub={true}
                    pagination={true}
                  />
                ) : (
                  <p
                    className=""
                    style={{
                      color: "#fff",
                      textAlign: "center",
                      marginTop: 100,
                    }}
                  >
                    No data found!
                  </p>
                )}
              </Tab>
            ) : null}

            {leaderscount?.role == "god_agent" &&
            leaderscount?.specialAccess?.length > 0 ? (
              <Tab eventKey="special" title="Special Access">
                <DataTableSpecialAccess
                  // setUserDel={setUserDel}
                  btcPrice={btcPrice}
                  tomiPrice={tomiPrice}
                  pepePrice={pepePrice}
                  linkPrice={linkPrice}
                  uniPrice={uniPrice}
                  dopPrice={dopPrice}
                  gemsPrice={gemsPrice}
                  currentPage={currentPage}
                  GetAllRounds={getSpecialAccessData}
                  pages={pages}
                  GetAgents={getSpecialAccessData}
                  page={page}
                  pageCount={pageCountAgent}
                  handlePageChange={handleAgentsPageChange}
                  offset={offset}
                  setOffset={setOffset}
                  agents={specialAccessData}
                  setAgents={setAgents}
                  setRoutes={setRoutes}
                  sub={true}
                />

                {/* <Specialaccess
                  specialAccess={specialAccess}
                  setUserDel={setUserDel}
                  setShow1={setShow1}
                /> */}
              </Tab>
            ) : null}
          </Tabs>
        </div>
      </section>

      <Modal
        className="add-mega-modal global-modal-scss"
        show={show1}
        onHide={handleClose1}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Special Access</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="multiselect-custom mt-5">
            <label className="custom-label">Special Access to</label>
            <Multiselect
              placeholder=""
              selectedValues={specialAccess?.map((item) => item?.name)}
              isObject={false}
              onKeyPressFn={function noRefCheck() {}}
              onRemove={function noRefCheck(selectedList, removedItem) {
                const selectedLeader = specialAccess.find(
                  (leader) => leader.name == removedItem
                );
                if (selectedLeader) {
                  const selectedId = selectedLeader._id;
                  const specialAccessExist = removeSpecialAccess?.find(
                    (leader) => leader == selectedId
                  );
                  if (!specialAccessExist) {
                    removeSpecialAccess.push(selectedId);
                  }
                  // Do whatever you need to with the selected id
                }
              }}
              onSearch={function noRefCheck() {}}
              onSelect={function noRefCheck(selectedList, selectedName) {
                const selectedLeader = godLeadersList.find(
                  (leader) => leader.name == selectedName
                );
                if (selectedLeader) {
                  const selectedId = selectedLeader._id;
                  const specialAccessExist = addSpecialAccess?.find(
                    (leader) => leader == selectedId
                  );
                  if (!specialAccessExist) {
                    addSpecialAccess.push(selectedId);
                  }
                  // Do whatever you need to with the selected id
                }
              }}
              customCloseIcon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M5.14307 12.8571L12.8574 5.14285"
                    stroke="black"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12.8574 12.8571L5.14307 5.14285"
                    stroke="black"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              }
              options={godLeadersList?.map((item) => item?.name)}
            />
          </div>
          <div className="twice-btn">
            <button
              onClick={() => {
                handleClose1();
              }}
              className="btn-cancel"
            >
              Back
            </button>
            <button
              disabled={loader}
              onClick={editSpecialAccessList}
              className="btn-add"
            >
              {loader ? "Edit..." : "Edit"}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="add-mega-modal global-modal-scss"
        show={show123}
        onHide={handleClose123}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Code Buying Limit</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="add-mega-div">
            <div className="option-field">
              <div className="material-textfield">
                <input
                  type="number"
                  placeholder="Buying Limit (USD)"
                  value={minimumBuy}
                  onChange={(e) => setMinimumBuy(e.target.value)}
                />
                <label>Buying Limit (USD)</label>
              </div>
            </div>
          </div>
          <div className="twice-btn">
            <button className="btn-cancel" onClick={() => setMinimumBuy("")}>
              Back
            </button>
            <button
              className="btn-add"
              onClick={() => {
                changeMinimumBuy();
              }}
            >
              Save
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="add-mega-modal global-modal-scss walletaddrssmodal"
        show={showchange}
        onHide={handleClosechange}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Change Wallet Address</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="walletaddrssmain">
            <p className="walletaddrsspara">Current Wallet Address</p>
            <h6 className="walletaddrsshead">{userDel?.walletAddress}</h6>
          </div>
          <div className="material-textfield">
            <input
              type="text"
              placeholder="Enter new wallet address"
              onChange={(e) => setNewWalletAddress(e.target.value)}
              value={newWalletAddress}
            />
            <label>New Wallet Address </label>
          </div>
          <div className="twice-btn">
            <button onClick={handleClosechange} className="btn-cancel">
              Cancel
            </button>
            <button
              className="btn-add"
              onClick={() => {
                handleClosechange();
                handleShowconfirmation();
              }}
            >
              Save
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="add-mega-modal global-modal-scss walletaddrssmodal"
        show={showconfirmation}
        onHide={handleCloseconfirmation}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="paraconfirm">
            Are you sure you want to change wallet address
          </p>
          <div className="twice-btn">
            <button onClick={handleCloseconfirmation} className="btn-cancel">
              Cancel
            </button>
            <button
              className="btn-add"
              onClick={() => {
                handleCloseconfirmation();
                handleShowchangesuccess();
              }}
            >
              Confirm
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="add-mega-modal global-modal-scss walletaddrssmodal"
        show={showchangesuccess}
        onHide={handleClosechangesuccess}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="ssuuccessmain">
            <img
              src="\assets\happy.svg"
              alt="successimg"
              className="successimg"
            />
            <p className="paraconfirm">Wallet address changed successfully</p>
            <button
              className="btn-okay w-100"
              onClick={handleClosechangesuccess}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ViewDetail;
